import CloseIcon from "../../assets/svg/CloseIcon";
import ESignatureICON from "../../assets/svg/EsignatureIcon";
import WarningIcon from "../../assets/svg/WarningIcon";
import BannerProps from "../../services/models/bannerProps.model";

function Banner({
  onClick,
  text,
  type,
  subHeading,
  hideButton = false,
  onClose,
  loading
}: Readonly<BannerProps>): JSX.Element | null {

  if (loading) {
    return <div className="p-5 flex bg-white rounded-md border-[1px] mt-9 items-center justify-between ">
      <div className="p-1.5 bg-dropDownBorder rounded-lg mx-3 w-full animate-pulse" />
    </div>
  }

  if (type === "cancel") {
    return (
      <div className="py-3 flex bg-pink border-requiredRed rounded-md border-[1px] mt-9 items-center justify-between px-3">
        <div className="flex items-center">
          <div className="text-requiredRed text-xs md:text-base">{text}</div>
        </div>
      </div>
    );
  } else if (type === "exception") {
    return (
      <div className="mx-28 py-3 flex bg-pink border-requiredRed rounded-md border-[1px] mt-9 items-center justify-between px-3">
        <div>
          <div className="flex items-center pb-3">
            <WarningIcon className="mr-3" />
            <p className="text-requiredRed font-semibold mr-2">
              Missing Information:{" "}
            </p>
            <p className="text-requiredRed mr-2">{subHeading}</p>
          </div>
          <div className="text-requiredRed text-xs md:text-base">{text}</div>
        </div>
      </div>
    );
  } else if (type === "info") {
    return (
      <div className="py-3 px-3 mt-9 flex items-center justify-between bg-teal-50 border-teal-500 border rounded-md">
        <div className="text-teal-600 text-xs md:text-base">{text}</div>

      </div>
    );
  } else {
    return null;
  }
}
export default Banner;
